import React from 'react';
import { projectsData } from '../work/Data';
import './certificates.css';

const Certificates = () => {
    // Filter to only get certificate items and reverse to show newest first
    const certificates = projectsData.filter(item => item.category === 'certificate').slice().reverse();

    return (
        <section className="certificates section" id="certificates">
            <h2 className="section__title">Certificates</h2>
            <span className="section__subtitle">My achievements & certifications</span>

            <div className="certificates-container container grid">
                {certificates.map((item) => {
                    return (
                        <div className="certificate-card" key={item.id}>
                            <div className="certificate-img-wrapper">
                                <img src={item.image} alt={item.title} className="certificate-img" />
                            </div>
                            <h3 className="certificate-title">{item.title}</h3>
                            {item.link ? (
                                <a 
                                    href={item.link} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="certificate-button"
                                >
                                    Lihat Kredensial <i className='bx bx-right-arrow-alt certificate-button-icon'></i>
                                </a>
                            ) : (
                                <span className="certificate-button certificate-button--disabled">
                                    Kredensial Tidak Tersedia
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default Certificates;
